export default function Dashboard({ fill, width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 1.8H7C7.66274 1.8 8.2 2.33726 8.2 3V7C8.2 7.66274 7.66274 8.2 7 8.2H3C2.33726 8.2 1.8 7.66274 1.8 7V3C1.8 2.33726 2.33726 1.8 3 1.8ZM0 3C0 1.34315 1.34315 0 3 0H7C8.65685 0 10 1.34315 10 3V7C10 8.65685 8.65685 10 7 10H3C1.34315 10 0 8.65685 0 7V3ZM3 13.3H7C7.66274 13.3 8.2 13.8373 8.2 14.5V18.5C8.2 19.1627 7.66274 19.7 7 19.7H3C2.33726 19.7 1.8 19.1627 1.8 18.5V14.5C1.8 13.8373 2.33726 13.3 3 13.3ZM0 14.5C0 12.8431 1.34315 11.5 3 11.5H7C8.65685 11.5 10 12.8431 10 14.5V18.5C10 20.1569 8.65685 21.5 7 21.5H3C1.34315 21.5 0 20.1569 0 18.5V14.5ZM18.5 1.8H14.5C13.8373 1.8 13.3 2.33726 13.3 3V7C13.3 7.66274 13.8373 8.2 14.5 8.2H18.5C19.1627 8.2 19.7 7.66274 19.7 7V3C19.7 2.33726 19.1627 1.8 18.5 1.8ZM14.5 0C12.8431 0 11.5 1.34315 11.5 3V7C11.5 8.65685 12.8431 10 14.5 10H18.5C20.1569 10 21.5 8.65685 21.5 7V3C21.5 1.34315 20.1569 0 18.5 0H14.5ZM16.5 19.7C14.7327 19.7 13.3 18.2673 13.3 16.5C13.3 14.7327 14.7327 13.3 16.5 13.3C18.2673 13.3 19.7 14.7327 19.7 16.5C19.7 18.2673 18.2673 19.7 16.5 19.7ZM11.5 16.5C11.5 13.7386 13.7386 11.5 16.5 11.5C19.2614 11.5 21.5 13.7386 21.5 16.5C21.5 19.2614 19.2614 21.5 16.5 21.5C13.7386 21.5 11.5 19.2614 11.5 16.5Z"
      />
    </svg>
  )
}
